import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ReactComponent as LogoSistema } from '../../assets/images/Logo_CDIEMS.svg';
import { Botao } from '../../components/Botao';
import Card from '../../components/Card';
import { Input } from '../../components/Input';
import { Seletor } from '../../components/Seletor';
import { ContextoUsuario } from '../../contextos/usuario/ProvedorUsuario';
import { LoginStore } from '../../stores/LoginStore';
import {
  ConteinerCard,
  ConteudoCard,
  Conteiner,
  Formulario,
  ConteinerCampo,
  AreaLogo,
} from './styles';

function Login() {
  const [dominios, atribuirDominios] = useState([]);

  const { autenticar } = useContext(ContextoUsuario);

  const formRef = useRef(null);

  const historico = useHistory();

  const params = new URLSearchParams(useLocation().search);

  const enviarFormulario = useCallback(
    async (data) => {
      formRef.current?.setErrors({});
      let error = false;

      if (data.dominio === '') {
        formRef.current?.setFieldError('dominio', 'Campo obrigatório');
        error = true;
      }
      if (data.usuario === '') {
        formRef.current?.setFieldError('usuario', 'Campo obrigatório');
        error = true;
      }
      if (data.senha === '') {
        formRef.current?.setFieldError('senha', 'Campo obrigatório');
        error = true;
      }

      if (error) {
        return;
      }

      await LoginStore.autenticar(data).then((response) => {
        if (response.status === 200) {
          toast.success('Bem-vindo!');
          autenticar(response.data);
          historico.push('/home');
        } else toast.error(response.data);
      });
    },
    [historico, autenticar],
  );

  const submeterFormulario = () => {
    formRef.current.submitForm();
  };

  useEffect(() => {
    const call = async () => {
      await LoginStore.obterDominios().then((response) => {
        if (response.status === 200) {
          atribuirDominios([
            { label: 'Selecione', value: '' },
            ...response.data.map((dom) => ({ label: dom, value: dom })),
          ]);
        } else if (response.status === 204) {
          toast.error('Não há domínios cadastrados');
        } else toast.error(response.data.mensagem);
      });
    };

    call();
  }, []);

  useEffect(() => {
    let login = { ta: params.get('ta'), h: params.get('h') };
    if (login.ta && login.h) {
      const call = async () => {
        await LoginStore.autenticarTaH(login).then((response) => {
          if (response.status === 200) {
            if (response.data.statusCode === 0) {
              toast.success('Bem-Vindo');
              autenticar(response.data.data);
              historico.push('/home');
            } else {
              toast.error('Usuário/senha ou domínio incorreto.');
            }
          } else if (response.status === 401) {
            toast.error(response.data.statusMessage);
          }
        });
      };
      call();
    }
  }, [autenticar, historico, params]);

  return (
    <Conteiner>
      <ConteinerCard>
        <Card>
          <ConteudoCard>
            <AreaLogo>
              <LogoSistema />
            </AreaLogo>
            <Formulario onSubmit={enviarFormulario} ref={formRef}>
              <ConteinerCampo>
                <Seletor titulo='Domínio' nome='dominio' opcoes={dominios} />
              </ConteinerCampo>
              <ConteinerCampo>
                <Input
                  titulo='Usuário'
                  nome='usuario'
                  placeholder={'Informe o usuário'}
                  aoPressionarEnter={submeterFormulario}
                />
              </ConteinerCampo>
              <ConteinerCampo>
                <Input
                  titulo='Senha'
                  nome='senha'
                  tipo='password'
                  placeholder={'Informe a senha'}
                  aoPressionarEnter={submeterFormulario}
                />
              </ConteinerCampo>
              <ConteinerCampo>
                <Botao texto='Entrar' tipo='submit' />
              </ConteinerCampo>
            </Formulario>
          </ConteudoCard>
        </Card>
      </ConteinerCard>
    </Conteiner>
  );
}

export default Login;
